import {
  Box,
  Paper,
  Typography,
  Grid,
  TextField, FormControl, 
  Button, MenuItem, Select, Dialog, DialogActions, IconButton,DialogContent, DialogContentText, DialogTitle, Divider,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import React, { useCallback, useState, useEffect } from "react";
import { getAuth } from "firebase/auth";
import { useTheme } from "@mui/material";
import { tokens } from "../../theme";
import "./ApproveLeave.css";
import DatePicker from "react-datepicker";
import { format } from 'date-fns';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';

const statusOptionsMap = {
  PENDING: ["APPROVED", "REJECTED"],
  "CANCEL-PENDING": ["CANCELLED", "CANCEL_REJECTED"]
};

const Leavedetails = () => {
  const navigate = useNavigate();
  const { applicationno } = useParams();
  const [application, setApplication] = useState([]); 
  const [loading, setLoading] = useState(true);
  const [leaveUpdates, setLeaveUpdates] = useState({}); 
  const [selectedStatus, setSelectedStatus] = useState("");
  const availableOptions = statusOptionsMap[application?.ApplicationStatus] || [];
  const [isProcessing, setIsProcessing] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [message, setMessage] = useState('');
  const theme = useTheme();
  const colors = tokens(theme.palette.mode); 
  const isDisabled =
  !availableOptions.length ||
  ["REJECTED", "CANCELLED", "CANCEL_REJECTED"].includes(application?.ApplicationStatus);
  const [openModal, setOpenModal] = useState(false);
  const [previewUrl, setPreviewUrl] = useState('');
  const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
 
  const fetchData = useCallback(() => {
    setLoading(true);
    const cachedData = sessionStorage.getItem("applications");

    if (cachedData) {
      const cachedApplications = JSON.parse(cachedData);
      const cachedApplication = cachedApplications.find(
        (app) => app.applicationno === applicationno
      );
      if (cachedApplication) {
        setApplication(cachedApplication); // Use cached data instantly
        setLoading(false);
        return;
      }
    }

    fetch(
      `${process.env.REACT_APP_BACKEND_URL_LMS}/application/${applicationno}`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      }
    )
      .then((res) => res.json())
      .then((data) => {
        console.log("Fetched Data for Application No:", data); // Log data to inspect the structure

        if (!data || typeof data !== "object") {
          console.error("❌ Unexpected Data Format:", data);
          setApplication({});
          return;
        }

        const processedData = {
          ...data,
          EL: data.emergencyleave ?? 0,
          PL: data.plannedleave ?? 0,
          comments: application.Comments || "",
          actualapproveleave: application.actualapproveleave || 0,
          ApprovedStartingDate: data.ApprovedStartingDate ?? "0",
          ApprovedEndingDate: data.ApprovedEndingDate ?? "0",
      };


        setApplication(processedData);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching application data:", error);
        setLoading(false);
        setApplication({});
      });
  }, [applicationno]); 

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (application?.ApplicationStatus) {
      setSelectedStatus(application.ApplicationStatus);
    }
  }, [application]);

  const handleUpdate = (applicationno, status = "APPROVED") => {
    return new Promise((resolve, reject) => {
      if (!application || application.applicationno !== applicationno) {
        reject("Application not found or mismatched");
        return;
      }

    const { actualapproveleave,  comments: updatedComment, startDate, endingdate } = leaveUpdates[applicationno] || {};

    const updatedCommentRaw = leaveUpdates[applicationno]?.comments;
    const trimmedUpdatedComment = updatedCommentRaw?.trim();
    const existingComment = application.comments?.trim();

    if (updatedCommentRaw !== undefined && trimmedUpdatedComment === "") {
      alert("Comments cannot be empty!");
      return;
    }

    const finalComment = trimmedUpdatedComment !== undefined ? trimmedUpdatedComment : existingComment;

    if (!finalComment) {
      alert("Comments cannot be empty!");
      return;
    }

    const approvedStartDate = startDate
      ? format(new Date(startDate), 'yyyy-MM-dd') 
      : application.startingdate;

    const approvedEndDate = endingdate
        ? format(new Date(endingdate), 'yyyy-MM-dd') 
        : application.endingdate;

    const auth = getAuth();
    const user = auth.currentUser;
    const updatedBy = user?.email || "Admin";
    const updatedApplicationData = {
        applicationno: application.applicationno,
        ApplicationStatus: status,
        userEmail: application.userEmail,
        leavetype: application.leavetype,
        LeavePurpose: application.LeavePurpose,
        noofdays: application.noofdays,
        startingdate: application.startingdate, 
        endingdate: application.endingdate,
        startingdateleavesession: application.startingdateleavesession,
        endingdateleavesession: application.endingdateleavesession,
        ApplyingDate: application.ApplyingDate,
        actualapproveleave: status === "APPROVED" ? (actualapproveleave || application.actualapproveleave) : application.actualapproveleave,
        comments: finalComment.trim(),
        ApprovedStartingDate: status === "APPROVED" ? approvedStartDate : application.ApprovedStartingDate,
        ApprovedEndingDate: status === "APPROVED" ? approvedEndDate : application.ApprovedEndingDate,
        approvedBy: updatedBy
    };



    // API request options
      fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/application-update`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json','Authorization': `Bearer ${accessToken}` },
          body: JSON.stringify([updatedApplicationData]),  // Ensure payload is an array
      })
      .then(res => res.json())
      .then(data => {
        setMessage('Status updated successfully');
        setApplication(updatedApplicationData);
        fetchData();
        resolve(data); 
      })
      .catch(error => console.error("Update failed:", error));
    });
  };


      const handleCommentChange = (applicationno, newComment) => {
        setLeaveUpdates((prev) => ({
          ...prev,
          [applicationno]: {
            ...prev[applicationno],
            comments: newComment,
          },
        }));
      };

      const handleActualApproveLeaveChange = (applicationno, value) => {
        setLeaveUpdates((prev) => ({
            ...prev,
            [applicationno]: {
                ...prev[applicationno],
                actualapproveleave: value,  // Update approved leave count
            },
        }));
      };

      const handleStartDateChange = (applicationno, date) => {
        setLeaveUpdates((prev) => {
          const existingUpdate = prev[applicationno] || {};
          return {
            ...prev,
            [applicationno]: {
              ...existingUpdate,
              startDate: date || existingUpdate.startDate || application.startingdate, // Preserve existing value if unchanged
            },
          };
        });
      };

      const handleEndDateChange = (applicationno, date) => {
        setLeaveUpdates((prev) => {
          const existingUpdate = prev[applicationno] || {};
          return {
            ...prev,
            [applicationno]: {
              ...existingUpdate,
              endingdate: date || existingUpdate.endingdate || application.endingdate, // Preserve existing value if unchanged
            },
          };
        });
      };

      const handleSave = () => {
        if (isProcessing) {
          return; 
        }
        setIsProcessing(true);
        if (selectedStatus === "APPROVED") {
          handleUpdate(application.applicationno, selectedStatus)
            .then(() => {
              setIsProcessing(false);
              navigate("/approveleave");
            })
            .catch(err => {
              setIsProcessing(false);
              console.error("Error updating application:", err);
            });
        } else if (selectedStatus === "REJECTED") {
          setIsProcessing(false);
          handleRejected(application.applicationno, selectedStatus); 
        } else if (selectedStatus === "PENDING") {
          setIsProcessing(false);
          navigate("/approveleave"); 
        }else if (selectedStatus === "CANCELLED") {
          handleCancelsatus()
            .then(() => {
              setMessage("Application cancelled successfully");
              fetchData();
              setIsProcessing(false);
              navigate("/approveleave");
            })
            .catch((err) => {
              console.error("Cancel failed:", err);
              setIsProcessing(false); 
            });
        
        } else if (selectedStatus === "CANCEL_REJECTED") {
          handleCancelRejected()
            .then(() => {
              setMessage("Application cancel rejected successfully");
              fetchData();
              setIsProcessing(false); 
              navigate("/approveleave");
            })
            .catch((err) => {
              console.error("Cancel rejected failed:", err);
              setIsProcessing(false); 
            });
        }

      };

      const handleRejected = (applicationno ) => {
        
        const applicationArray = Array.isArray(application) ? application : [application];

        const updatedRow = applicationArray.find(app => app.applicationno === applicationno);
        if (!updatedRow) return console.error("Application not found");

        const finalComment =
          leaveUpdates[applicationno]?.comments?.trim() ?? application.Comments ?? "";

        if (!finalComment) {
          return alert("Please enter a comment before rejecting the application.");
        }

        // Prepare payload for API request
        const updatedApplicationData = {
            applicationno: updatedRow.applicationno,
            ApplicationStatus: "REJECTED",
            comments: finalComment, // Keep comments
        };



        // API request options
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" ,'Authorization': `Bearer ${accessToken}`},
            body: JSON.stringify([updatedApplicationData]),  // Payload should be an array
        };

        // Send update request
        fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/application-reject`, requestOptions)
            .then(res => res.json())
            .then(() => {
                setMessage("Application rejected successfully");
                fetchData();  // Refresh data after update
                navigate("/approveleave");
            })
            .catch(error => console.error(error));
      };
  
      const handleCancelsatus = () => {
        const { applicationno } = application;
        const finalComment =
          leaveUpdates[applicationno]?.comments?.trim() ?? application.Comments ?? "";
      
        if (!finalComment) {
          alert("Comments are required for cancellation.");
          return Promise.reject("Missing comment");
        }
      
        const updatedApplicationData = {
          applicationno,
          ApplicationStatus: selectedStatus, // should be "CANCELLED"
          comments: finalComment,
          ActualApproveLeave : application.ActualApproveLeave,
          userEmail: application.userEmail,
          leavetype: application.leavetype,
          startingdate: application.startingdate, 
          endingdate: application.endingdate,
          startingdateleavesession: application.startingdateleavesession,
          endingdateleavesession: application.endingdateleavesession,
          ApprovedStartingDate:  application.ApprovedStartingDate,
          ApprovedEndingDate: application.ApprovedEndingDate,
        };
      
      
        return fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/application-cancel-action`, {
          method: "POST",
          headers: { "Content-Type": "application/json",'Authorization': `Bearer ${accessToken}` },
          body: JSON.stringify([updatedApplicationData]),
        })
          .then((res) => res.json())
          .then((data) => {
            setMessage("Application cancelled successfully");
            fetchData(); // Refresh updated data
            navigate("/approveleave");
          })
          .catch((error) => {
            console.error("Cancel action failed:", error);
            throw error;
          });
      };
      
    
    const handleCancelRejected = () => {
      const { applicationno } = application;
      const finalComment =
        leaveUpdates[applicationno]?.comments?.trim() ?? application.Comments ?? "";

      if (!finalComment) {
        alert("Comments are required for cancel rejection.");
        return;
      }

      const updatedApplicationData = {
        applicationno,
        ApplicationStatus: selectedStatus,
        comments: finalComment,
      };

      return fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/application-cancel-action`, {
        method: "POST",
        headers: { "Content-Type": "application/json",'Authorization': `Bearer ${accessToken}` },
        body: JSON.stringify([updatedApplicationData]),
      })
        .then((res) => res.json())
        .then(() => {
          setMessage("Application cancel rejected successfully");
          fetchData();
          navigate("/approveleave");
        })
        .catch((error) => {
          console.error("Cancel reject failed:", error);
        });
    };


      const handleCancel = () => {
        setOpenDialog(true);
      };

      const handleDialogClose = (confirm) => {
        setOpenDialog(false);
        if (confirm) {
          navigate("/ApproveLeave"); // Navigate only if user confirms
        }
      };

      const handleOpenModal = (fileUrl) => {
        setPreviewUrl(fileUrl);
        setOpenModal(true);
      };
    
      const handleCloseModal = () => {
        setOpenModal(false);
        setPreviewUrl('');
      };

        const getTextFieldBorderStyle = (colors) => ({
          borderRadius: "8px",
          backgroundColor: "transparent",
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: colors.grey[300],
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: colors.greenAccent[500], 
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: colors.greenAccent[500], 
          },
        });
      

  return (
    <Box sx={{flexGrow: 1, width: "100%", minHeight: "100vh", overflowY: "auto",  py: 4,px: 2,  display: "flex",  justifyContent: "center", }}>
      <Paper
        variant="outlined" 
        elevation={0}
        sx={{ width: "820px", height:"fit-content", maxWidth: "100%", p: 3,borderRadius: 2, backgroundColor: colors.primary[400],  display: "flex",  flexDirection: "column",
        overflow: "hidden", }}
      >
      <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1.5, pl: 1, color: colors.grey[100], }}>
        Application ID:{" "}
        <span style={{ color: "gray", fontWeight: "normal" }}>{applicationno}</span>
      </Typography>

        <Box sx={{ width: "100%"}}>
          <Divider sx={{ borderBottomWidth: 2, borderColor: "gray",mb: 2 }} />
        </Box>

        {loading ? (
          <Typography>Loading...</Typography>
        ) : (
          application && (
            <Grid
              container
              spacing={2}
              sx={{mt: 3,display: "flex",   maxWidth: "900px",mx: "auto",pr:2, alignItems: "flex-start", width: "100%",textAlign: "left", }}
            >
               <Grid item xs={12} sm={6}>
                  <FormControl fullWidth variant="outlined" disabled={isDisabled}>
                    <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: colors.grey[100], mb: 0.5 }}>
                      Application Status
                    </Typography>

                    <Select
                      labelId="application-status-label"
                      id="application-status"
                      value={selectedStatus}
                      onChange={(e) => setSelectedStatus(e.target.value)}
                      displayEmpty
                      InputLabelProps={{ sx: { fontSize: "16px" ,} }}
                      disabled={isDisabled}
                      sx={{
                        
                        color: colors.grey[100],
                        ...getTextFieldBorderStyle(colors),
                        "& .MuiSvgIcon-root": {
                          color: colors.grey[100],
                        },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            backgroundColor: theme.palette.mode === "dark"
                              ? colors.primary[400]
                              : colors.primary[100],
                            color: colors.grey[100],
                          },
                        },
                      }}
                    >
                      {/* Show selected value first */}
                     
                        <MenuItem value={selectedStatus} disabled>
                          {selectedStatus?.replace(/_/g, " ")}
                        </MenuItem>
          

                      {/* Show available options if editable */}
                      {!isDisabled &&
                        availableOptions.map((option) => (
                          <MenuItem key={option} value={option}
                            sx={{
                              color: colors.grey[100],
                            }}
                          >
                            {option.replace(/_/g, " ")}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
               </Grid>
              <Grid item xs={12} sm={6}>
                <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: colors.grey[100], mb: 0.5 }}>
                  Applying Date
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  value={application.ApplyingDate || ""}
                  InputProps={{
                    readOnly: true,
                    sx: {
                        ...getTextFieldBorderStyle(colors),
                      },
                  }}
                  InputLabelProps={{ sx: { fontSize: "16px" ,
                    color: colors.grey[100],
                    "&.Mui-focused": {
                      color: colors.grey[100], 
                    },
                    "&.MuiInputLabel-shrink": {
                      color: colors.grey[100], 
                    },
                  } }}
                  sx={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: colors.grey[100], mb: 0.5 }}>
                  Leave Type
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                   value={
                      application.leavetype === "EL"
                        ? "Emergency Leave"
                        : application.leavetype === "PL"
                        ? "Planned Leave"
                        : application.leavetype === "TL" || application.leavetype === "Tentative_Leave_Plan"
                        ? "Tentative Leave"
                        : application.leavetype || ""
                    }
                  InputProps={{
                    readOnly: true,
                    sx: {
                        ...getTextFieldBorderStyle(colors),
                      },
                  }}
                  InputLabelProps={{ sx: {  fontSize: "16px" ,
                    color: colors.grey[100],
                    "&.Mui-focused": {
                      color: colors.grey[100], 
                    },
                    "&.MuiInputLabel-shrink": {
                      color: colors.grey[100], 
                    },
                  } }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: colors.grey[100], mb: 0.5 }}>
                  No of Days
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  value={application.noofdays || ""}
                  InputProps={{
                    readOnly: true,
                    sx: {
                        ...getTextFieldBorderStyle(colors),
                      },
                  }}
                  InputLabelProps={{ sx: { fontSize: "16px",color: colors.grey[100],
                    "&.Mui-focused": {
                      color: colors.grey[100], 
                    },
                    "&.MuiInputLabel-shrink": {
                      color: colors.grey[100], 
                    }, } }}
               
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: colors.grey[100], mb: 0.5 }}>
                  Starting Date
                </Typography>
                <DatePicker
                  selected={
                    leaveUpdates[application.applicationno]?.startDate
                      ? new Date(leaveUpdates[application.applicationno].startDate)
                      : application.ApprovedStartingDate && application.ApprovedStartingDate !== "-"
                        ? new Date(application.ApprovedStartingDate)
                        : application.startingdate
                          ? new Date(application.startingdate)
                          : null
                  }
                  onChange={(date) => handleStartDateChange(application.applicationno, date)}
                  dateFormat="MM/dd/yyyy"
                  popperClassName="custom-datepicker-popper"
                  customInput={
                    <TextField
                      variant="outlined"
                      fullWidth
                      sx={{
                        ...getTextFieldBorderStyle(colors),
                      }}
                      InputLabelProps={{ shrink: true, sx: { fontSize: "16px",color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100], 
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100], 
                        }, } }}
                    />
                  }
                />
              </Grid>
              {/* Ending Date Picker */}
              <Grid item xs={12} sm={6}>
                <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: colors.grey[100], mb: 0.5 }}>
                  Ending Date
                </Typography>
                <DatePicker
                  selected={
                    leaveUpdates[application.applicationno]?.endingdate
                      ? new Date(leaveUpdates[application.applicationno].endingdate)
                      : application.ApprovedEndingDate && application.ApprovedEndingDate !== "-"
                        ? new Date(application.ApprovedEndingDate)
                        : application.endingdate
                          ? new Date(application.endingdate)
                          : null
                  }
                  onChange={(date) => handleEndDateChange(application.applicationno, date)}
                  dateFormat="MM/dd/yyyy"
                  popperClassName="custom-datepicker-popper"
                  customInput={
                    <TextField
                      variant="outlined"
                      fullWidth
                      sx={{
                        ...getTextFieldBorderStyle(colors),
                      }}
                      InputLabelProps={{ shrink: true, sx: {  fontSize: "16px",color: colors.grey[100],
                        "&.Mui-focused": {
                          color: colors.grey[100], 
                        },
                        "&.MuiInputLabel-shrink": {
                          color: colors.grey[100], 
                        }, } }}
                    />
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: colors.grey[100], mb: 0.5 }}>
                  User Email
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  value={application.userEmail || ""}
                  InputProps={{
                    readOnly: true,
                    sx:{
                        ...getTextFieldBorderStyle(colors),
                      }
                  }}
                  InputLabelProps={{ sx: { fontSize: "16px",color: colors.grey[100],
                    "&.Mui-focused": {
                      color: colors.grey[100], 
                    },
                    "&.MuiInputLabel-shrink": {
                      color: colors.grey[100], 
                    },} }}
                  
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: colors.grey[100], mb: 0.5 }}>
                  Reason
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  value={application.LeavePurpose || ""}
                  InputProps={{
                    readOnly: true,
                    sx: {
                        ...getTextFieldBorderStyle(colors),
                      },
                  }}
                  InputLabelProps={{ sx: { fontSize: "16px",color: colors.grey[100],
                    "&.Mui-focused": {
                      color: colors.grey[100], 
                    },
                    "&.MuiInputLabel-shrink": {
                      color: colors.grey[100], 
                    }, } }}
                  
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: colors.grey[100], mb: 0.5 }}>
                  User name
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  value={application.username || "-"}
                  InputProps={{
                    readOnly: true,
                    sx: {
                        ...getTextFieldBorderStyle(colors),
                      },
                  }}
                  InputLabelProps={{shrink: true, sx: { fontSize: "16px",color: colors.grey[100],
                    "&.Mui-focused": {
                      color: colors.grey[100], 
                    },
                    "&.MuiInputLabel-shrink": {
                      color: colors.grey[100], 
                    }, } }}
                  
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: colors.grey[100], mb: 0.5 }}>
                  Actual Approve Leave
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  value={
                    leaveUpdates[application.applicationno]?.actualapproveleave ??
                    application.actualapproveleave ??
                    "-"
                  }
                  onChange={(e) => handleActualApproveLeaveChange(application.applicationno, e.target.value)}
                  InputProps={{
                    readOnly: true,
                    sx: {
                        ...getTextFieldBorderStyle(colors),
                      },
                  }}
                  InputLabelProps={{ shrink: true , sx: {  fontSize: "16px",color: colors.grey[100],
                    "&.Mui-focused": {
                      color: colors.grey[100], 
                    },
                    "&.MuiInputLabel-shrink": {
                      color: colors.grey[100], 
                    }, } }}
              
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: colors.grey[100], mb: 0.5 }}>
                  employee comment
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  value={application.employee_comment || "-"}
                  InputProps={{
                    readOnly: true,
                    sx: {
                        ...getTextFieldBorderStyle(colors),
                      },
                  }}
                  InputLabelProps={{ sx: {  fontSize: "16px" ,
                    color: colors.grey[100],
                    "&.Mui-focused": {
                      color: colors.grey[100], 
                    },
                    "&.MuiInputLabel-shrink": {
                      color: colors.grey[100], 
                    },
                  } }}
                />
              </Grid>
              <Grid item xs={12} sm={6} sx={{ position: 'relative' }}>
                <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: colors.grey[100], mb: 0.5 }}>
                  Uploaded Files
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  value={
                    application.uploaded_files && Object.keys(application.uploaded_files).length > 0
                      ? `${Object.keys(application.uploaded_files).length} FILE(S)`
                      : "No files uploaded"
                  }
                  InputProps={{
                    readOnly: true,
                    sx: {
                        ...getTextFieldBorderStyle(colors),
                      },
                  }}
                  InputLabelProps={{
                    sx: {  fontSize: "16px", color: "#999" },
                  }}
                  sx={{ textAlign: "center", cursor: 'pointer' }}
                  onClick={() => {
                    if (application.uploaded_files && Object.keys(application.uploaded_files).length > 0) {
                      const firstFileUrl = Object.values(application.uploaded_files)[0];
                      handleOpenModal(firstFileUrl); // Open modal with the first file URL
                    }
                  }}
                />

                {/* Eye Icon to view the files */}
                <IconButton
                  sx={{
                    position: 'absolute',
                    right: 10,  
                    top: '70%',
                    transform: 'translateY(-50%)',  
                    color: "#007BFF",
                  }}
                  onClick={() => {
                    if (application.uploaded_files && Object.keys(application.uploaded_files).length > 0) {
                      const firstFileUrl = Object.values(application.uploaded_files)[0];
                      handleOpenModal(firstFileUrl); // Open modal with the first file URL
                    }
                  }}
                >
                  <VisibilityIcon />
                </IconButton>

                {/* Dialog Box for File Preview */}
                <Dialog open={openModal} onClose={handleCloseModal} maxWidth={false} 
                  PaperProps={{
                    sx: {
                      width: '55vw',
                      height: '90vh',
                      maxWidth: 'none',
                    }
                  }}>
                  <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 2 }}>
                    File Preview
                    <IconButton onClick={handleCloseModal}>
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>

                  <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100%', overflow: 'hidden' }}>
                    {previewUrl.endsWith('.pdf') ? (
                      <iframe src={previewUrl} width="100%" height="500px" title="PDF Preview" />
                    ) : previewUrl.endsWith('.mp4') ? (
                      <video width="100%" height="auto" controls>
                        <source src={previewUrl} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    ) : (
                      <img src={previewUrl} alt="Preview" style={{ maxWidth: '100%', maxHeight: '700px' }} />
                    )}
                    <Button variant="contained" color="primary" sx={{ mt: 2 }} href={previewUrl} download>
                      Download
                    </Button>
                  </DialogContent>
                </Dialog>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: colors.grey[100], mb: 0.5 }}>
                  Comments
                </Typography>
                <TextField
                  variant="outlined"
                  placeholder="Enter your comments here..."
                  fullWidth
                  value={
                    leaveUpdates[application.applicationno]?.comments !== undefined
                      ? leaveUpdates[application.applicationno].comments
                      : application.Comments ?? ""
                  }
                  onChange={(e) =>
                    handleCommentChange(application.applicationno, e.target.value)
                  }
                  InputProps={{
                    sx: {
                        ...getTextFieldBorderStyle(colors),
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                    sx: { fontSize: "16px",color: colors.grey[100],
                      "&.Mui-focused": {
                        color: colors.grey[100], 
                      },
                      "&.MuiInputLabel-shrink": {
                        color: colors.grey[100], 
                      }, },
                  }}
                />
            </Grid>
              
            </Grid>
          )
        )}
        
        <Box display="flex" gap={1}  justifyContent="flex-end" sx={{ mt: 5,mr:2 }} >
          <>
          <Button variant="contained" color="success" onClick={handleSave} sx={{ width: 130, fontWeight: "bold" }}>
            Save
          </Button>

            <Button variant="contained" color="error" onClick={handleCancel} sx={{ width: 130, fontWeight: "bold" }}>
              Cancel
            </Button>

            {/* Confirmation Dialog */}
            <Dialog open={openDialog} onClose={() => handleDialogClose(false)} fullWidth  maxWidth="sm"
              sx={{display: "flex",alignItems: "center",justifyContent: "center",}}
                PaperProps={{sx: {backgroundColor: "#f8f9fa",borderRadius: "10px", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",  minWidth: "400px", }, }}
            >
              <DialogTitle sx={{ fontSize: "18px", fontWeight: "bold", color:"#003366"}}>Confirm Navigation</DialogTitle>
              <DialogContent>
                <DialogContentText sx={{ fontSize: "16px", color: "#333" }}>
                  Do you want to go back without saving the changes?
                </DialogContentText>
              </DialogContent>
              <DialogActions sx={{ justifyContent: "flex-end", padding: "16px" }}>
                <Button onClick={() => handleDialogClose(false)} color="primary" variant="contained">
                  No
                </Button>
                <Button onClick={() => handleDialogClose(true)} color="error" variant="contained" autoFocus>
                  Yes
                </Button>
              </DialogActions>
            </Dialog>
          </>
        </Box>
      </Paper>
    </Box>
  );
};

export default Leavedetails;
